import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Rating from 'react-rating';
import 'font-awesome/css/font-awesome.min.css';
import Swal from 'sweetalert2';

const DownloadDialogue = ({ onClose }) => {
    const [androidExpanded, setAndroidExpanded] = useState(false);
    const [iOSExpanded, setIOSExpanded] = useState(false);

    const toggleAndroid = () => {
        if (!androidExpanded) {
            setIOSExpanded(false);
        }
        setAndroidExpanded(!androidExpanded);
    };

    const toggleiOS = () => {
        if (!iOSExpanded) {
            setAndroidExpanded(false);
        }
        setIOSExpanded(!iOSExpanded);
    };
  return (
    <>
      <Overlay />
      <StyledDonateDialogue>
        <h3>Choose your platform</h3>
        <Platforms>
            <Heading onClick={toggleAndroid}>
                <i className='fa fa-android' style={{ color: '#78C257' }}/>
                <span> Android</span>
            </Heading>
            <Heading onClick={toggleiOS}>
                <i className='fa fa-apple' />
                <span> iOS</span>
            </Heading>
        </Platforms>
        {androidExpanded && (
            <Content>
                <h4>Installation Guide - Android</h4>
                <Instructions>
                    <Step>Open <b>Chrome</b> and navigate to ConnectKGP</Step>
                    <Step>At the top right, click <b>More</b> <img src='images/chrome_more.svg' alt='more icon'/> and then <b>Install as App</b></Step>
                    <Step>Click on <b>Install</b></Step>
                    <Step>Make sure your <b>Chrome</b> browser is updated</Step>
                </Instructions>
            </Content>
        )}
        {iOSExpanded && (
            <Content>
                <h4>Installation Guide - iOS</h4>
                <Instructions>
                    <Step>Open <b>Safari</b> and navigate to ConnectKGP</Step>
                    <Step>At the bottom center, click on <b>Share</b> <img src='images/share_ios.png' alt='share icon'/></Step>
                    <Step>Scroll down and select <b>Add to Home Screen</b></Step>
                    <Step>Click on <b>Add</b></Step>
                </Instructions>
            </Content>
        )}
        <CloseButton onClick={onClose} style={{"color": "black"}}><i className="fa fa-close" /></CloseButton>
      </StyledDonateDialogue>
    </>
  );
};

export default DownloadDialogue;

const StyledDonateDialogue = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  border-radius: 10px;
  background: #fff;
  align-items: center;
  position: absolute;
  padding: 20px 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  h3 {
    margin: 20px 0;
    font-size: 2em;
    color: #6559A2;
  }

  @media only screen and (max-width: 600px) {
    width: 90%;
    background: #fff;
    padding: 20px 5px;

    h3 {
        font-size : 22px;
    }
}
`;

const CloseButton = styled.button`
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const Platforms = styled.div`
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
    justify-content: center;
`;

const Heading = styled.div`
    text-align: center;
    padding: 30px 40px;
    border-radius: 5px;
    background: rgba(217, 217, 217, 0.5);
    box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;
`;

const Content = styled.div`
    text-align: left;
    width: 80%;

    h4 {
        margin: 0;
    }
`;

const Instructions = styled.ol`
    padding-inline-start: 5%;
`;

const Step = styled.li`
    font-size: 12px;
    margin-bottom: 2%;

    img {
        vertical-align: middle;
    }
`;